import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './mobile.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

window.__CDH_SW_UPDATE__ = null;
window.__CDH_SET_SW_UPDATE__ = null;

serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    if (typeof window.__CDH_SET_SW_UPDATE__ === 'function') {
      window.__CDH_SET_SW_UPDATE__(registration);
    } else {
      window.__CDH_SW_UPDATE__ = registration;
    }
  },
  onSuccess: () => {
    console.log('PWA cache attiva');
  },
});

reportWebVitals();
